export const blank = {
	"Version": 4,
	"System": "sfrpg",
	"Level": 1,
	"Current": {
		"Ammunition": [],
		"Armor": 0,
		"Points": {
			"Hit": 1,
			"Stamina": 1,
			"Resolve": 1,
			"Temporary": {
				"Max": 0,
				"Heal": 0,
				"HP": 0,
				"Active": false,
			}
		},
		"SpellSlots": {
			"0": 0,
			"1": 0,
			"2": 0,
			"3": 0,
			"4": 0,
			"5": 0,
			"6": 0
		}
	},
	"Bio": {
		"Character Name": "Unnamed Character",
		"ShortDescription": "Unknown 1",
		"LongDescription": "",
		"Gender": "",
		"Theme": "",
		"Speed": "30'",
		"Homeworld": "",
		"Languages": "",
		"Alignment": "",
		"Deity": "",
		"Player": "",
		"Image": "/assets/img/portraits/Zenka.png",
		"Race": {
			"Name": "",
			"Size": "",
			"Type": "",
			"Hit Points": 0,
			"Properties": []
		}
	},
	"AbilityScores": {
		"Base": {
			"Strength": 10,
			"Dexterity": 10,
			"Constitution": 10,
			"Intelligence": 10,
			"Wisdom": 10,
			"Charisma": 10
		},
		"Race": {
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0
		},
		"Theme": {
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0
		},
		"Upgrades": {
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0
		},
		"Temporary": {
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0
		},
	},
	"Misc": {
		"Initiative": 0,
		"Resolve": 0,
		"CarryCapacity": 0,
		"HasCompanion": false,
		"CastingStat": '',
		"SpellSaveDCMod": 0,
	},
	"Skills": {
		"Acrobatics": {
			"Ability": "Dexterity",
			"Untrained": true,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0,
			"ArmorCheck": true
		},
		"Athletics": {
			"Ability": "Strength",
			"Untrained": true,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0,
			"ArmorCheck": true
		},
		"Bluff": {
			"Ability": "Charisma",
			"Untrained": true,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Computers": {
			"Ability": "Intelligence",
			"Untrained": false,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Culture": {
			"Ability": "Intelligence",
			"Untrained": false,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Diplomacy": {
			"Ability": "Charisma",
			"Untrained": true,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Disguise": {
			"Ability": "Charisma",
			"Untrained": true,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Engineering": {
			"Ability": "Intelligence",
			"Untrained": false,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Intimidate": {
			"Ability": "Charisma",
			"Untrained": true,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Life Science": {
			"Ability": "Intelligence",
			"Untrained": false,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Medicine": {
			"Ability": "Intelligence",
			"Untrained": false,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Mysticism": {
			"Ability": "Wisdom",
			"Untrained": false,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Perception": {
			"Ability": "Wisdom",
			"Untrained": true,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Physical Science": {
			"Ability": "Intelligence",
			"Untrained": false,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Piloting": {
			"Ability": "Dexterity",
			"Untrained": true,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Profession1": {
			"Name": "",
			"Ability": "",
			"Untrained": false,
			"Ranks": 0,
			"ClassSkill": true,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Profession2": {
			"Name": "",
			"Ability": "",
			"Untrained": false,
			"Ranks": 0,
			"ClassSkill": true,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Sense Motive": {
			"Ability": "Wisdom",
			"Untrained": true,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Sleight of Hand": {
			"Ability": "Dexterity",
			"Untrained": false,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0,
			"ArmorCheck": true
		},
		"Stealth": {
			"Ability": "Dexterity",
			"Untrained": true,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0,
			"ArmorCheck": true
		},
		"Survival": {
			"Ability": "Wisdom",
			"Untrained": true,
			"Ranks": 0,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		}
	},
	"Levels": {
		"1": {
			"Class": "",
			"Level": 1,
			"BAB": 0,
			"Fort": 0,
			"Ref": 0,
			"Will": 0,
			"HP": 0,
			"SP": 0,
			"SkillRanks": 0,
			"Skills": {
				"Acrobatics": 0,
				"Athletics": 0,
				"Bluff": 0,
				"Computers": 0,
				"Culture": 0,
				"Diplomacy": 0,
				"Disguise": 0,
				"Engineering": 0,
				"Intimidate": 0,
				"Life Science": 0,
				"Medicine": 0,
				"Mysticism": 0,
				"Perception": 0,
				"Physical Science": 0,
				"Piloting": 0,
				"Profession1": 0,
				"Profession2": 0,
				"Sense Motive": 0,
				"Sleight of Hand": 0,
				"Stealth": 0,
				"Survival": 0
			},
			"Feats": [{
				"Name": "",
				"Description": ""
			}, ],
			"Theme": {
				"Name": "",
				"Description": ""
			},
			"Abilities": [],
			"Spells": {
				"PerDay": {
					"1": 0,
					"2": 0,
					"3": 0,
					"4": 0,
					"5": 0,
					"6": 0
				},
				"Known": {
					"0": 0,
					"1": 0,
					"2": 0,
					"3": 0,
					"4": 0,
					"5": 0,
					"6": 0
				},
				"List": {}
			}
		},
	},
	"KeyAbility": "",
	"Equipment": {
		"Armor": [{
			"Level": 1,
			"Name": "",
			"Price": 0,
			"EAC": 0,
			"KAC": 0,
			"MaxDex": 0,
			"ArmorCheck": 0,
			"Speed": 0,
			"UpgradeSlots": 0,
			"Bulk": 0,
			"Upgrades": [],
			"Misc": {
				"EAC": 0,
				"KAC": 0,
				"CM": 0
			}
		}],
		"Credits": 1000,
		"Equipped": [],
		"Augmentation": [],
		"Magic": [],
		"Stored": [],
		"Shield": {
			"Level": 1,
			"Name": '',
			"Price": 0,
			"BonusWielded": 0,
			"BonusAligned": 0,
			"MaxDex": 0,
			"ArmorCheck": 0,
			"Bulk": 0,
			"UpgradeSlots": 0,
			"Upgrades": []
		},
		"Weapons": [],
	},
	"Society": {
		"ID": "",
		"Number": "",
		"Fame": "",
		"Infamy": "",
		"Factions": {
			"Acquisitives": 0,
			"Dataphiles": 0,
			"Exo-guardians": 0,
			"Second Seekers": 0,
			"Wayfinders": 0,
			"Other": 0
		},
		"InventoryLog": []
	},
	"Journal": []
}

export const zenka = {
	"Bio": {
		"Character Name": "Zenka",
		"Gender": "Host",
		"Theme": "Ace Pilot",
		"Speed": "30'",
		"Homeworld": "Akiton",
		"Languages": "",
		"Alignment": "Chaotic Good",
		"Deity": "None",
		"Player": "Trevor",
		"Image": "https://character.gallery/assets/img/portraits/Zenka.png",
		"Race": {
			"Name": "Shirren",
			"Size": "Medium",
			"Type": "Humanoid(shirren)",
			"Hit Points": 6,
			"Properties": [{
					"Name": "Blindsense",
					"Description": "Shirrens’ sensitive antennae grant them blindsense (vibration)—the ability to sense vibrations in the air—out to 30 feet. A shirren ignores the Stealth bonuses from any form of visual camouflage, invisibility, and the like when attempting a Perception check opposed by a creature’s Stealth check. Even on a successful Perception check, any foe that can’t be seen still has total concealment (50% miss chance) against a shirren, and the shirren still has the normal miss chance when attacking foes that have concealment. A shirren is still flat-footed against attacks from creatures it can’t see."
				},
				{
					"Name": "Communalism",
					"Description": "Shirrens are used to working with others as part of a team. Once per day, as long as an ally is within 10 feet, a shirren can roll a single attack roll or skill check twice and take the higher result."
				},
				{
					"Name": "Cultural Fascination",
					"Description": "Shirrens are eager to learn about new cultures and societies. Shirrens receive a +2 racial bonus to Culture and Diplomacy checks"
				},
				{
					"Name": "Limited Telepathy",
					"Description": "Shirrens can communicate telepathically with any creatures within 30 feet with whom they share a language. Conversing telepathically with multiple creatures simultaneously is just as difficult as listening to multiple people speak."
				}
			]
		},
		"ShortDescription": "Technomancer 5",
		"LongDescription": ""
	},
	"AbilityScores": {
		"Base": {
			"Strength": 10,
			"Dexterity": 13,
			"Constitution": 10,
			"Intelligence": 16,
			"Wisdom": 10,
			"Charisma": 11
		},
		"Race": {
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 2,
			"Intelligence": 0,
			"Wisdom": 2,
			"Charisma": -2
		},
		"Theme": {
			"Strength": 0,
			"Dexterity": 1,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0
		},
		"Upgrades": {
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0
		},
		"Temporary": {
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0
		}
	},
	"Misc": {
		"Initiative": 0,
		"Resolve": 0,
		"CarryCapacity": 2,
		"CastingStat": "Intelligence",
		"SpellSaveDCMod": 0
	},
	"Skills": {
		"Acrobatics": {
			"Ability": "Dexterity",
			"Untrained": true,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0,
			"ArmorCheck": true
		},
		"Athletics": {
			"Ability": "Strength",
			"Untrained": true,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0,
			"ArmorCheck": true
		},
		"Bluff": {
			"Ability": "Charisma",
			"Untrained": true,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Computers": {
			"Ability": "Intelligence",
			"Untrained": false,
			"ClassSkill": true,
			"Insight": 1,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Culture": {
			"Ability": "Intelligence",
			"Untrained": false,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 2,
			"Theme": 0,
			"Misc": 0
		},
		"Diplomacy": {
			"Ability": "Charisma",
			"Untrained": true,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 2,
			"Theme": 0,
			"Misc": 0
		},
		"Disguise": {
			"Ability": "Charisma",
			"Untrained": true,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Engineering": {
			"Ability": "Intelligence",
			"Untrained": false,
			"ClassSkill": true,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Intimidate": {
			"Ability": "Charisma",
			"Untrained": true,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Life Science": {
			"Ability": "Intelligence",
			"Untrained": false,
			"ClassSkill": true,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Medicine": {
			"Ability": "Intelligence",
			"Untrained": false,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Mysticism": {
			"Ability": "Wisdom",
			"Untrained": false,
			"ClassSkill": true,
			"Insight": 1,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Perception": {
			"Ability": "Wisdom",
			"Untrained": true,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Physical Science": {
			"Ability": "Intelligence",
			"Untrained": false,
			"ClassSkill": true,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Piloting": {
			"Ability": "Dexterity",
			"Untrained": true,
			"ClassSkill": true,
			"Insight": 3,
			"Race": 0,
			"Theme": 1,
			"Misc": 0
		},
		"Profession1": {
			"Name": "",
			"Ability": "Intelligence",
			"Untrained": false,
			"ClassSkill": true,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Profession2": {
			"Name": "",
			"Ability": "Intelligence",
			"Untrained": false,
			"ClassSkill": true,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Sense Motive": {
			"Ability": "Wisdom",
			"Untrained": true,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		},
		"Sleight of Hand": {
			"Ability": "Dexterity",
			"Untrained": false,
			"ClassSkill": true,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0,
			"ArmorCheck": true
		},
		"Stealth": {
			"Ability": "Dexterity",
			"Untrained": true,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0,
			"ArmorCheck": true
		},
		"Survival": {
			"Ability": "Wisdom",
			"Untrained": true,
			"ClassSkill": false,
			"Insight": 0,
			"Race": 0,
			"Theme": 0,
			"Misc": 0
		}
	},
	"Levels": {
		"1": {
			"Class": "Technomancer",
			"Level": 1,
			"BAB": 0,
			"Fort": 0,
			"Ref": 0,
			"Will": 2,
			"HP": 5,
			"SP": 5,
			"RP": 4,
			"Skills": {
				"Acrobatics": 1,
				"Athletics": 0,
				"Bluff": 0,
				"Computers": 1,
				"Culture": 0,
				"Diplomacy": 0,
				"Disguise": 0,
				"Engineering": 1,
				"Intimidate": 0,
				"Life Science": 0,
				"Medicine": 0,
				"Mysticism": 1,
				"Perception": 0,
				"Physical Science": 1,
				"Piloting": 1,
				"Profession1": 0,
				"Profession2": 0,
				"Sense Motive": 0,
				"Sleight of Hand": 1,
				"Stealth": 0,
				"Survival": 0
			},
			"Theme": {
				"Name": "Theme Knowledge",
				"Description": "You are obsessed with starships and vehicles, and have committed to memory almost every related tidbit of knowledge you’ve ever come across. Reduce the DC of Culture checks to recall knowledge about starship and vehicle models and parts as well as famous hotshot pilots by 5. Piloting is a class skill for you, though if it is a class skill from the class you take at 1st level, you instead gain a +1 bonus to your Piloting checks. In addition, you gain an ability adjustment of +1 to Dexterity at character creation."
			},
			"Abilities": [],
			"Spells": {
				"PerDay": {
					"1": 3,
					"2": 0,
					"3": 0,
					"4": 0,
					"5": 0,
					"6": 0
				},
				"Known": {
					"0": 4,
					"1": 2,
					"2": 0,
					"3": 0,
					"4": 0,
					"5": 0,
					"6": 0
				},
				"List": {
					"0": [{
							"Name": "Dancing Lights",
							"Link": ""
						},
						{
							"Name": "Mending",
							"Link": ""
						},
						{
							"Name": "Psychokinetic Hand",
							"Link": ""
						},
						{
							"Name": "Transfer Charge",
							"Link": ""
						}
					],
					"1": [{
							"Name": "Flight",
							"Link": ""
						},
						{
							"Name": "Overheat",
							"Link": ""
						}
					]
				}
			},
			"SkillRanks": 4,
			"Feats": [{
				"Name": "Skill Focus (Piloting)",
				"Description": "You are particularly adept at a certain skill.\n - Benefit: Choose a skill. You gain a +3 insight bonus to checks involving the chosen skill.\n - Special: You can take this feat multiple times. Its effects don’t stack. Each time you take this feat, it applies to a new skill."
			}]
		},
		"2": {
			"Class": "Technomancer",
			"Level": 2,
			"BAB": 1,
			"Fort": 0,
			"Ref": 0,
			"Will": 3,
			"HP": 5,
			"SP": 5,
			"RP": 4,
			"Skills": {
				"Acrobatics": 0,
				"Athletics": 0,
				"Bluff": 0,
				"Computers": 1,
				"Culture": 1,
				"Diplomacy": 1,
				"Disguise": 0,
				"Engineering": 1,
				"Intimidate": 0,
				"Life Science": 1,
				"Medicine": 0,
				"Mysticism": 0,
				"Perception": 1,
				"Physical Science": 0,
				"Piloting": 1,
				"Profession1": 0,
				"Profession2": 0,
				"Sense Motive": 0,
				"Sleight of Hand": 0,
				"Stealth": 0,
				"Survival": 0
			},
			"Abilities": [{
				"Name": "Magic Hack: Energize Spell (Ex)",
				"Description": "Once per day as a move action, you can use a battery or a weapon’s power cell to power your spellcasting, enabling you to cast one spell you know without using a spell slot. This expends 20 charges per spell level from the battery or power cell and requires you to touch the battery, power cell, or weapon. You must cast the spell before the start of your next turn, or the charges are wasted with no effect."
			}],
			"Spells": {
				"PerDay": {
					"1": 3,
					"2": 0,
					"3": 0,
					"4": 0,
					"5": 0,
					"6": 0
				},
				"Known": {
					"0": 5,
					"1": 3,
					"2": 0,
					"3": 0,
					"4": 0,
					"5": 0,
					"6": 0
				},
				"List": {
					"0": [{
							"Name": "Dancing Lights",
							"Link": ""
						},
						{
							"Name": "Mending",
							"Link": ""
						},
						{
							"Name": "Psychokinetic Hand",
							"Link": ""
						},
						{
							"Name": "Transfer Charge",
							"Link": ""
						},
						{
							"Name": "Energy Ray",
							"Link": ""
						}
					],
					"1": [{
							"Name": "Flight",
							"Link": ""
						},
						{
							"Name": "Overheat",
							"Link": ""
						},
						{
							"Name": "Supercharge Weapon",
							"Link": ""
						}
					]
				}
			},
			"SkillRanks": 4,
			"Feats": []
		},
		"3": {
			"Class": "Technomancer",
			"Level": 3,
			"BAB": 2,
			"Fort": 1,
			"Ref": 1,
			"Will": 3,
			"HP": 5,
			"SP": 5,
			"RP": 4,
			"Skills": {
				"Acrobatics": 1,
				"Athletics": 0,
				"Bluff": 0,
				"Computers": 1,
				"Culture": 0,
				"Diplomacy": 0,
				"Disguise": 0,
				"Engineering": 1,
				"Intimidate": 0,
				"Life Science": 0,
				"Medicine": 0,
				"Mysticism": 1,
				"Perception": 0,
				"Physical Science": 0,
				"Piloting": 1,
				"Profession1": 0,
				"Profession2": 0,
				"Sense Motive": 1,
				"Sleight of Hand": 0,
				"Stealth": 0,
				"Survival": 1
			},
			"Abilities": [],
			"Spells": {
				"PerDay": {
					"1": 4,
					"2": 0,
					"3": 0,
					"4": 0,
					"5": 0,
					"6": 0
				},
				"Known": {
					"0": 6,
					"1": 4,
					"2": 0,
					"3": 0,
					"4": 0,
					"5": 0,
					"6": 0
				},
				"List": {
					"0": [{
							"Name": "Dancing Lights",
							"Link": ""
						},
						{
							"Name": "Mending",
							"Link": ""
						},
						{
							"Name": "Psychokinetic Hand",
							"Link": ""
						},
						{
							"Name": "Transfer Charge",
							"Link": ""
						},
						{
							"Name": "Energy Ray",
							"Link": ""
						},
						{
							"Name": "Detect Magic",
							"Link": ""
						}
					],
					"1": [{
							"Name": "Flight",
							"Link": ""
						},
						{
							"Name": "Overheat",
							"Link": ""
						},
						{
							"Name": "Supercharge Weapon",
							"Link": ""
						},
						{
							"Name": "Unseen Servant",
							"Link": ""
						}
					]
				}
			},
			"SkillRanks": 4,
			"Feats": [{
				"Name": "Spell Penetration",
				"Description": "Your spells break through spell resistance more easily than those of other spellcasters.\n - Benefit: You gain a +2 bonus to caster level checks to overcome a creature’s spell resistance."
			}]
		},
		"4": {
			"Class": "Technomancer",
			"Level": 4,
			"BAB": 3,
			"Fort": 1,
			"Ref": 1,
			"Will": 4,
			"HP": 5,
			"SP": 5,
			"RP": 5,
			"Skills": {
				"Acrobatics": 0,
				"Athletics": 0,
				"Bluff": 0,
				"Computers": 1,
				"Culture": 0,
				"Diplomacy": 0,
				"Disguise": 0,
				"Engineering": 1,
				"Intimidate": 0,
				"Life Science": 0,
				"Medicine": 1,
				"Mysticism": 1,
				"Perception": 0,
				"Physical Science": 1,
				"Piloting": 1,
				"Profession1": 0,
				"Profession2": 0,
				"Sense Motive": 0,
				"Sleight of Hand": 0,
				"Stealth": 1,
				"Survival": 0
			},
			"Abilities": [],
			"Spells": {
				"PerDay": {
					"1": 4,
					"2": 3,
					"3": 0,
					"4": 0,
					"5": 0,
					"6": 0
				},
				"Known": {
					"0": 6,
					"1": 4,
					"2": 2,
					"3": 0,
					"4": 0,
					"5": 0,
					"6": 0
				},
				"List": {
					"0": [{
							"Name": "Dancing Lights",
							"Link": ""
						},
						{
							"Name": "Mending",
							"Link": ""
						},
						{
							"Name": "Psychokinetic Hand",
							"Link": ""
						},
						{
							"Name": "Transfer Charge",
							"Link": ""
						},
						{
							"Name": "Energy Ray",
							"Link": ""
						},
						{
							"Name": "Detect Magic",
							"Link": ""
						}
					],
					"1": [{
							"Name": "Flight",
							"Link": ""
						},
						{
							"Name": "Overheat",
							"Link": ""
						},
						{
							"Name": "Supercharge Weapon",
							"Link": ""
						},
						{
							"Name": "Magic Missile",
							"Link": ""
						}
					],
					"2": [{
							"Name": "Microbot Assault",
							"Link": ""
						},
						{
							"Name": "Recharge",
							"Link": ""
						}
					]
				}
			},
			"SkillRanks": 4,
			"Feats": []
		},
		"5": {
			"Class": "Technomancer",
			"BAB": 3,
			"Fort": 1,
			"Ref": 1,
			"Will": 4,
			"HP": 5,
			"SP": 5,
			"Skills": {
				"Acrobatics": 1,
				"Athletics": 0,
				"Bluff": 1,
				"Computers": 1,
				"Culture": 0,
				"Diplomacy": 0,
				"Disguise": 0,
				"Engineering": 1,
				"Intimidate": 0,
				"Life Science": 1,
				"Medicine": 2,
				"Mysticism": 1,
				"Perception": 1,
				"Physical Science": 1,
				"Piloting": 1,
				"Profession1": 0,
				"Profession2": 0,
				"Sense Motive": 1,
				"Sleight of Hand": 0,
				"Stealth": 0,
				"Survival": 0
			},
			"Abilities": [{
				"Name": "Magic Hack: Debug Spell (Ex)",
				"Description": "Any piece of code has bugs, but you can turn the bugs in your spellcode into features. After rolling damage for an instantaneous spell that deals Hit Point damage, you can spend 1 Resolve Point to reroll one die with a result of 1 (see page 243).\nAt 11th level, you can reroll up to two dice with a result of 1, and at 17th level, you can reroll up to three dice with a result of 1.\nFor example, if you were 17th level and cast disintegrate, you could spend 1 Resolve Point to reroll up to three dice that rolled 1s, after rolling and seeing how many 1s you rolled."
			}, ],
			"Spells": {
				"PerDay": {
					"1": 5,
					"2": 3,
					"3": 0,
					"4": 0,
					"5": 0,
					"6": 0
				},
				"Known": {
					"0": 6,
					"1": 4,
					"2": 3,
					"3": 0,
					"4": 0,
					"5": 0,
					"6": 0
				},
				"List": {
					"0": [{
							"Name": "Dancing Lights",
							"Link": ""
						},
						{
							"Name": "Mending",
							"Link": ""
						},
						{
							"Name": "Psychokinetic Hand",
							"Link": ""
						},
						{
							"Name": "Transfer Charge",
							"Link": ""
						},
						{
							"Name": "Energy Ray",
							"Link": ""
						},
						{
							"Name": "Detect Magic",
							"Link": ""
						}
					],
					"1": [{
							"Name": "Flight",
							"Link": ""
						},
						{
							"Name": "Overheat",
							"Link": ""
						},
						{
							"Name": "Supercharge Weapon",
							"Link": ""
						},
						{
							"Name": "Unseen Servant",
							"Link": ""
						}
					],
					"2": [{
							"Name": "Caustic Conversion",
							"Link": ""
						},
						{
							"Name": "Microbot Assault",
							"Link": ""
						},
						{
							"Name": "Invisibility",
							"Link": ""
						}
					]
				}
			},
			"AbilityIncreases": {
				"Strength": 0,
				"Dexterity": 2,
				"Constitution": 2,
				"Intelligence": 2,
				"Wisdom": 2,
				"Charisma": 0
			},
			"SkillRanks": 4,
			"Feats": [{
				"Name": "Sky Jockey",
				"Description": "You can get the most out of flying technology.\n- Prerequisites: Piloting 5 ranks.\n- Benefit: When you’re using a device to fly (including magic items, but not spells or natural flight), your fly speed increases by 10 feet. If you are operating a flying vehicle, its fly speed increases by 10 (though this has no impact on its full speed or overland movement speed). When you are in the pilot role of starship combat, your starship’s speed increases by 1."
			}]
		}
	},
	"KeyAbility": "Intelligence",
	"Armor": [{
		"Level": 5,
		"Name": "Estex Suit II",
		"Price": 2700,
		"EAC": 4,
		"KAC": 5,
		"MaxDex": 5,
		"ArmorCheck": -1,
		"Speed": 0,
		"UpgradeSlots": 3,
		"Bulk": 1,
		"Upgrades": [{
				"Name": "Infrared Sensors",
				"Description": "Darkvision 60ft.",
				"Capacity": "",
				"Price": 0,
				"Bulk": 0
			},
			{
				"Name": "",
				"Description": "",
				"Capacity": "",
				"Price": 0,
				"Bulk": 0
			},
			{
				"Name": "",
				"Description": "",
				"Capacity": "",
				"Price": 0,
				"Bulk": 0
			}
		],
		"Misc": {
			"EAC": 0,
			"KAC": 0,
			"CM": 0
		}
	}],
	"Equipment": {
		"Credits": 257,
		"Equipped": [],
		"Augmentation": [],
		"Magic": [],
		"Stored": [{
			"Type": "Backpack, Industrial",
			"Price": 25,
			"Bulk": 1,
			"Extradimensional": false,
			"Contents": [{
					"Name": "Hygiene Kit",
					"Level": 1,
					"UnitPrice": 3,
					"UnitBulk": 1,
					"Qty": 1
				},
				{
					"Name": "R2E",
					"Level": 1,
					"UnitPrice": 1,
					"UnitBulk": 0.1,
					"Qty": 3
				},
				{
					"Name": "Medpatch",
					"Level": 1,
					"UnitPrice": 50,
					"UnitBulk": 0.1,
					"Qty": 2
				},
				{
					"Name": "Serum of Healing Mk 1",
					"Level": 1,
					"UnitPrice": 50,
					"UnitBulk": 0.1,
					"Qty": 2
				},
				{
					"Name": "Tent (Mobile Hotelier)",
					"Level": 1,
					"UnitPrice": 50,
					"UnitBulk": 1,
					"Qty": 1
				},
				{
					"Name": "Navigator's Kit",
					"Level": 1,
					"UnitPrice": 20,
					"UnitBulk": 0.1,
					"Qty": 1
				},
				{
					"Name": "Battery",
					"Level": 1,
					"UnitPrice": 60,
					"UnitBulk": 0,
					"Qty": 1
				},
				{
					"Name": "Flare",
					"Level": 1,
					"UnitPrice": 5,
					"UnitBulk": 0,
					"Qty": 12
				},
				{
					"Level": 1,
					"Name": "Battery (expended)",
					"Qty": 1,
					"UnitBulk": 0,
					"UnitPrice": 60
				},
				{
					"Level": 1,
					"Name": "Battery (17 Charges)",
					"Qty": 1,
					"UnitBulk": 0,
					"UnitPrice": 60
				},
				{
					"Level": 1,
					"Name": "Battery (10 Charges)",
					"Qty": 1,
					"UnitBulk": 0,
					"UnitPrice": 60
				}
			]
		}],
		"Shield": {
			"Level": 1,
			"Name": "",
			"Price": 0,
			"BonusWielded": 0,
			"BonusAligned": 0,
			"MaxDex": 0,
			"ArmorCheck": 0,
			"Bulk": 0,
			"UpgradeSlots": 0,
			"Upgrades": []
		},
		"Weapons": [{
				"Name": "Static Arc Pistol",
				"AttackType": "Ranged",
				"AttackMisc": 0,
				"Level": 2,
				"Price": 750,
				"Damage": "1d6+2 E",
				"Range": "50 ft",
				"Critical": "Arc 2, Anchoring",
				"AmmoType": "Battery",
				"Capacity": 20,
				"Usage": 2,
				"Bulk": 0.1,
				"Special": "Stun"
			},
			{
				"Name": "Flare Gun, Survival",
				"AttackType": "Ranged",
				"AttackMisc": 0,
				"Level": 1,
				"Price": 90,
				"Damage": "1d3+2 F",
				"Range": "30 ft",
				"Critical": "Burn 1d6",
				"AmmoType": "Flare",
				"Capacity": 1,
				"Usage": 1,
				"Bulk": 0.1,
				"Special": "Analog, Bright"
			},
			{
				"Name": "Knife, Survival",
				"AttackType": "Operative",
				"AttackMisc": 0,
				"Level": 1,
				"Price": 95,
				"Damage": "1d4+2 S",
				"Range": "-",
				"Critical": "-",
				"AmmoType": "",
				"Capacity": 0,
				"Usage": 0,
				"Bulk": 0.1,
				"Special": "Analog, Operative"
			}
		],
		"Armor": [{
			"Level": 5,
			"Name": "Estex Suit II",
			"Price": 2700,
			"EAC": 4,
			"KAC": 5,
			"MaxDex": 5,
			"ArmorCheck": -1,
			"Speed": 0,
			"UpgradeSlots": 3,
			"Bulk": 1,
			"Upgrades": [{
					"Name": "Infrared Sensors",
					"Description": "Darkvision 60ft.",
					"Capacity": "",
					"Price": 0,
					"Bulk": 0
				},
				{
					"Name": "",
					"Description": "",
					"Capacity": "",
					"Price": 0,
					"Bulk": 0
				},
				{
					"Name": "",
					"Description": "",
					"Capacity": "",
					"Price": 0,
					"Bulk": 0
				}
			],
			"Misc": {
				"EAC": 0,
				"KAC": 0,
				"CM": 0
			}
		}]
	},
	"Society": {
		"ID": "57622",
		"Number": "7XX",
		"Fame": "",
		"Infamy": "",
		"Factions": {
			"Acquisitives": 0,
			"Dataphiles": 0,
			"Exo-guardians": 0,
			"Second Seekers": 0,
			"Wayfinders": 0,
			"Other": 0
		},
		"InventoryLog": [{
			"Item": "",
			"Cost": "",
			"Bought": "",
			"Sold": "",
			"Expended": ""
		}]
	},
	"Journal": [{
			"Date": "2017-12-02",
			"Description": "Getting setup on Absalom Station and dealing w/ gangs",
			"XP": "950",
			"Rewards": "",
			"Leveled": "No",
			"Died": "No"
		},
		{
			"Date": "2018-01-06",
			"Description": "Acquired the Sunrise Maiden",
			"XP": "3100",
			"Rewards": "",
			"Leveled": "Twice",
			"Died": "Almost"
		},
		{
			"Date": "2018-02-10",
			"Description": "Fixed up the Maiden, went off to college on Castrovel",
			"XP": "750",
			"Rewards": "",
			"Leveled": "No",
			"Died": "No"
		},
		{
			"Date": "2018-03-24",
			"Description": "Got chased by stampeding dinosaurs in the Castrovelean wilderness",
			"XP": "1375",
			"Rewards": "",
			"Leveled": "Yes",
			"Died": "Almost"
		},
		{
			"Date": "2018-04-21",
			"Description": "Statue of an elf woman, and got chased by plant monsters",
			"XP": "2300",
			"Rewards": "",
			"Leveled": "No",
			"Died": "No"
		},
		{
			"Date": "2018-05-12",
			"Description": "Canoodling for mountain eels, Solarians are nasty, ",
			"XP": "",
			"Rewards": "",
			"Leveled": "Yes",
			"Died": ""
		}
	],
	"Version": 4,
	"System": "sfrpg",
	"Level": 5,
	"Current": {
		"Ammunition": [
			20,
			1,
			0
		],
		"Armor": 0,
		"Points": {
			"Hit": 31,
			"Stamina": 35,
			"Resolve": 6,
			"Temporary": {
				"Active": false,
				"HP": 0,
				"Heal": 0,
				"Max": 0
			}
		},
		"SpellSlots": {
			"0": 0,
			"1": 5,
			"2": 3,
			"3": 0,
			"4": 0,
			"5": 0,
			"6": 0
		}
	}
}